export const testimonials = [
  {
    id: 1,
    name: 'Taylor R',
    location: 'LA',
    rating: 5,
    text: 'I got Benji from Chris & Nancy about 2 months ago. They have made it so easy for me. I got to FaceTime Benji whenever I wanted. I couldn’t have picked a better dog. All my kids love him so much. He goes everywhere with me. He’s truly a blessing to our family. If I ever get another frenchie, I would so return back to them.',
  },
  {
    id: 2,
    name: 'Christine C',
    location: 'FL',
    rating: 5,
    text: 'I had a such positive experience purchasing our puppy Newt from Chris at Gator Skin Frenchies in Louisiana. Chris demonstrated extensive knowledge and provided assistance throughout the process. Gator Skin Frenchies even recommended a pet transport company and they were just great. Newt arrived happy and healthy. The ongoing support from Chris and his wife has been greatly appreciated, contributing to our utmost satisfaction with our new fur-baby. I wholeheartedly recommend Gator Skin Frenchies to anyone seeking a well-bred, joyful French Bulldog. I cannot wait to get another puppy from them in the near future.',
  },
  {
    id: 3,
    name: 'Tiffany P',
    location: 'LA',
    rating: 5,
    text: "I highly recommend Gator Skin Frenchies. I had the best experience adopting our puppy from them. They were quick to respond to my inquiries and messages, answered all of my questions and helped to educate me on how to take care of our beautiful puppy. I was very impressed that she was well on her way to being potty trained when we got her. They also gave us a bag with some food, a toy and a collar.  Our dog is a very healthy, happy puppy. We love her so much. Thank you Gator Skin Frenchies!!!",
  },
  {
    id: 4,
    name: 'Crystal R',
    location: 'LA',
    rating: 5,
    text: "We bought Nitro from gator skins it was very easy getting in touch with them. They were able to answer all questions & concerns. Had paperwork and a cute little toy, dog food etc ready for us to have when we picked him up. We absolutely love having him apart of our family ❤️",
  },
];